import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Select, {createFilter} from "react-select";
import { useTable } from "react-table";
import { getTerminalSurchargeInfoServiceApi, TerminalMgmtApi } from "../Api";
import {toast} from "react-toastify";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

function Fees(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState();
  const [isEditable, setIsEditable] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [feeType, setFeeType] = useState();
  const [amount, setAmount] = useState();
  const [priority, setPriority] = useState();
  const [overRideType, setOverRideType] = useState();
  const [overRideValue, setOverRideValue] = useState();
  const [data, setData] = useState();
  const [isDefaultSurchargeEditable, setIsDefaultSurchargeEditable] =
    useState(false);
  const [isOverRideVisible, setIsOverRideVisible] = useState(false);
  const [terminalData, setTerminalData] = useState();
  const [surcharges, setSurcharges] = useState(false);
  const [defaultFeetype, setDefaultFeeType] = useState();
  const [defaultAmount, setDefaultAmount] = useState();

  const columns = [
    {
      Header: "Priority",
      accessor: "priority",
    },
    {
      Header: "Fee Type",
      accessor: "feeType",
        Cell: (props) => {
            return props.value == 2 ? "Fixed Dollar" : "Percentage";
        },
    },
    {
      Header: "Fee Amount",
      accessor: "feeAmt",
    },
    {
      Header: "Override Rules",
      accessor: "overrideTypeLabel",
    },
    {
      Header: "Override Values",
      accessor: "overrideData",
    },
  ];

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered  small">
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      // onClick={() => console.log(row.original)}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
  // useEffect(() => {

  // }, [props.terminalData]);
    const getDefaultTermianlData = async () => {
        const result = await axios.get(
            `getTerminalDetailsByID?termId=${location.search?.split("=")?.[1]}&searchCriteria=""&lastTxn=10`);
        setTerminalData(result?.data?.response?.[0]);
    };
  useEffect(() => {
    const fetchTerminals = () => {
      //   setTerminalsData(result.data);
      props?.terminalsData?.map((item, index) => {
        setTerminalSelectData((options) => [
          ...options,
          { label: item.terminalID, value: item.terminalID },
        ]);
      });
      const terminalId = location?.search?.split("=")?.[1];
      setSelectedTerminal({ label: terminalId, value: terminalId });
    };

    const getSurchargeOverRides = async () => {
      const result = await axios.get(`${getTerminalSurchargeInfoServiceApi}?paramTermID=${location.search?.split("=")?.[1]}`);
      // console.log(result,"result %%%%")
      setSurcharges(result.data?.response);
    };
    getDefaultTermianlData();
    fetchTerminals();
    getSurchargeOverRides();
    return () => {
      setTerminalSelectData([]);
    };
  }, [location]);
  const handleTerminalSelectClick = () => {
    history.push({
      pathname: "/termManagement/terMinalDetails",
      search: `terminalID=${selectedTerminal.value}`,
    });
  };
  const handleEditClick = () => {
    console.log("clik");
    setIsEditable(true);
    setIsDefaultSurchargeEditable(true);

  };
  const handleSaveOverRideValue = async () => {
    try {
        console.log("overRideType.value ",priority)

       const result =
         await axios.get(`saveTerminalOverrideSurcharge?paramTermID=${location?.search?.split("=")?.[1]}&paramPriority=${priority.value}&paramOverrideType=${overRideType.value}&paramOverrideData=${typeof overRideValue === "object"?overRideValue.value:overRideValue}&paramFeeType=${feeType.value}&paramFeeAmt=${amount}&paramCurrentUserID=${loggedUserStorage}&paramOverrideID=-1`);

      const data = {
        feeType: feeType?.value,
        feeAmt: amount,
        priority: priority?.value,
        overrideTypeLabel: overRideType?.label,
        ...(overRideType.value == "TranType"
          ? { overrideData: overRideValue?.label }
          : { overrideData: typeof overRideValue === "object"?overRideValue.value:overRideValue }),
      };
      setSurcharges((prev) => [...prev, data]);
      setFeeType()
      setAmount()
      setOverRideType()
      setPriority()
      setOverRideValue()
      setIsOverRideVisible(false);
        setIsDefaultSurchargeEditable(false);
    } catch (error) {}
  };


  const handleSaveDefaultTerminalSurcharge = async () => {
      let sendDefaultFeeType;
      let sendDefaultAmount;
      if(!defaultFeetype){
          sendDefaultFeeType = terminalData.feeType == 2
              ? { label: "Fixed Dollar", value: "2" }
              : { label: "Percentage", value: "3" }
      }
      if(!defaultAmount){
          sendDefaultAmount = (terminalData?.defaultFee/100) || 0
      }
      console.log(terminalData, " -=-=-=-=-= ",defaultAmount,"-----Exception",defaultFeetype," --- ")
    try {

      const result = await axios.get(
        `saveDefaultTerminalSurcharge?paramTermID=${
          location?.search?.split("=")?.[1]
        }&paramFeeType=${defaultFeetype?.value || sendDefaultFeeType.value}&paramFeeAmt=${defaultAmount || sendDefaultAmount}`
      );
      // Again call the api of default surcharge to get updated value in UI
      const res = await axios.get(
        `getTerminalSurchargeInfoService?paramTermID=${
          location?.search?.split("=")?.[1]
        }`
      );
      // set the new data in terminal
        getDefaultTermianlData();
        setTerminalData(res?.data?.response?.[0]);
        setIsEditable(false);
      setIsDefaultSurchargeEditable(false);
        setIsOverRideVisible(false);
    } catch (error) {
        toast.error('Please validate input been provided', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
        console.log("-----Exception",error)}
  };
  return (
    <div>
      <div className="mt-3">
        <form>
          <div class="form-group form-inline">
            <label for="exampleInputEmail1">Terminal ID:</label>
            <div class="input-group ml-2">
              <Select
                options={terminalSelectData}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                value={selectedTerminal}
                onChange={(e) => setSelectedTerminal(e)}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "13vw",
                  }),
                }}
              />
              <span
                class="input-group-text"
                role="button"
                onClick={handleTerminalSelectClick}
              >
                Go
              </span>
            </div>
          </div>
        </form>
      </div>
      {/*  */}
      <div className="border border-primary p-2">
        <div className="mt-3">
          <h6 style={{ fontWeight: "bold" }}>Default Terminal Surcharge</h6>
          {!isDefaultSurchargeEditable ? (
              terminalData?.feeType == 2?<h6>Amount:  ${(terminalData?.defaultFee/100) || 0}</h6>
                  :<h6>Amount:  %{(terminalData?.defaultFee/100) || 0}</h6>

          ) : (
            <div class="form-group form-inline">
              <label for="exampleInputEmail1">Amount: {terminalData?.feeType == 2? '$':'%'}</label>
                {console.log("---- terminalData?.defaultFee/100",terminalData?.defaultFee)}
              <input type="number"
                class="form-control"
                style={{ marginLeft: "2.3%" }}
                onChange={(e) => setDefaultAmount(e.target.value)}
                /*value={terminalData?.defaultFee/100}*/
                defaultValue={(terminalData?.defaultFee/100) || 0}
              />

            </div>
          )}
          {isDefaultSurchargeEditable ? (
            <div class="form-group form-inline">
              <label for="exampleInputEmail1">Fee Type:</label>
              <div class="input-group ml-4">

                <Select
                  options={[
                    { label: "Fixed Dollar", value: "2" },
                    { label: "Percentage", value: "3" },
                  ]}
                  defaultValue={
                    terminalData?.feeType == 2
                      ? { label: "Fixed Dollar", value: "2"}
                      : { label: "Percentage", value: "3" }
                  }
                  onChange={(e) => setDefaultFeeType(e)}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "13vw",
                    }),
                  }}
                />
              </div>
            </div>
          ) : (
            <h6>
              Type: {terminalData?.feeType == 2 ? "Fixed Dollar" : "Percentage"}
            </h6>
          )}
        </div>
        {/*  */}
        <div className="mt-3">
          <h6 style={{ fontWeight: "bold" }}>Surcharge Overrides</h6>
          {surcharges?.length > 0 ? (
            <div>
              <Table columns={columns} data={surcharges} />
            </div>
          ) : (
            <>
              <div class="form-group form-inline">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="No Data Available"
                    disabled
                  />
                </div>
              </div>
              <h6 style={{ color: "red" }}>
                Surcharge Overrides will be checked by SmartAquirer in ascending
                priority The first override that matchees all override rules
                will be applied to transaction. if no override rules match the
                transaction the default surcharge will be applied.{" "}
              </h6>
            </>
          )}

          {!isEditable ? (
            <div className="d-flex justify-content-center mt-3">
              <span
                class="input-group-text"
                role="button"
                onClick={() => handleEditClick()}
              >
                Edit
              </span>
            </div>
          ) : (
            <div className="d-flex">
              <span
                class="input-group-text mt-3"
                role="button"
                onClick={() => {
                  setIsOverRideVisible(true);
                }}
              >
                Add Override
              </span>
            </div>
          )}
        </div>
      </div>
      {isOverRideVisible ? (
        <div className="p-2 border border-primary">
          <div>
            <h6>You are adding new Surcharge Override:</h6>
          </div>
          <div className="mt-4">
            <div class="form-group form-inline">
              <label for="exampleInputEmail1">Fee Type:</label>
              <div class="input-group ml-5">
                <Select
                  options={[
                    { label: "Fixed Dollar", value: "2" },
                    { label: "Percentage", value: "3" },
                  ]}
                  value={feeType || { label: "", value: "" }}
                  onChange={(e) => setFeeType(e)}
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "13vw",
                    }),
                  }}
                />
              </div>
            </div>
            <div class="form-group form-inline">
              <label for="exampleInputEmail1">*Amount:</label>
              <input
                type="email"
                class="form-control ml-5"
                onChange={(e) => setAmount(e?.target?.value)}
              />
            </div>
            <div class="form-group form-inline">
              <label for="exampleInputEmail1">Priority:</label>
              {/*<input
                type="email"
                className="form-control"
                style={{ marginLeft: "7.8%" }}
                onChange={(e) => setPriority(e.target.value)}
              />*/}
                <Select
                    options={[
                        { label: "High", value: "0" },
                        { label: "Medium", value: "1" },
                        { label: "Low", value: "2" },
                    ]}
                    value={priority || { label: "", value: "" }}
                    onChange={(e) => setPriority(e)}

                    styles={{
                        container: (provided) => ({
                            ...provided,
                            flex: 1,
                            width: "5vw",
                        }),
                    }}
                />
            </div>
            <div class="form-group form-inline">
              <label for="exampleInputEmail1">Override Type:</label>
              <div class="input-group ml-3">
                <Select
                  options={[
                    { label: "Under Amount", value: "1" },
                    { label: "BIN", value: "0" },
                    { label: "TranType", value: "2" },
                    { label: "Over Amount", value: "3" },
                  ]}
                  value={overRideType || { label: "", value: "" }}
                  onChange={(e) => setOverRideType(e)}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "13vw",
                    }),
                  }}
                />
              </div>
            </div>
            {overRideType?.label == "TranType" ? (
              <div class="form-group form-inline">
                <label for="exampleInputEmail1">Override Value:</label>
                <div class="input-group ml-3">
                  <Select
                    options={[
                      { label: "Deposit", value: "DEP" },
                      { label: "Inquiry", value: "INQ" },
                      { label: "Pre-Auth Completion", value: "PAC" },
                      { label: "Pinless Credit Adv", value: "PCA" },
                      { label: "Cash Club Credit", value: "PCC" },
                      { label: "Pre-Authorization", value: "PRE" },
                      { label: "Purchase", value: "PUR" },
                      { label: "Merchandise Return", value: "RET" },
                      { label: "Signature Debit", value: "SPR" },
                      { label: "Statement Request", value: "STM" },
                      { label: "Transfer", value: "TSF" },
                      { label: "Void Return", value: "VRE" },
                      { label: "Void Sale", value: "VSA" },
                      { label: "Withdrawal", value: "WTH" },
                    ]}
                    value={overRideValue || { label: "", value: "" }}
                    onChange={(e) => setOverRideValue(e)}
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        flex: 1,
                        width: "13vw",
                      }),
                    }}
                  />
                </div>
              </div>
            ) : (
              <div class="form-group form-inline">
                <label for="exampleInputEmail1">Override value:</label>
                <input
                  type="email"
                  class="form-control ml-3"
                  onChange={(e) => setOverRideValue(e.target.value)}
                />
              </div>
            )}

            <div className="d-flex justify-content-start">
              <span
                class="input-group-text"
                role="button"
                onClick={() => {
                  handleSaveOverRideValue();
                }}
              >
                Save Override
              </span>
              <span
                class="input-group-text ml-3"
                role="button"
                onClick={() => {
                  setIsOverRideVisible(false);
                }}
              >
                Cancel Override
              </span>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {isDefaultSurchargeEditable ? (
        <div className="d-flex justify-content-start mt-3">
          <span
            class="input-group-text"
            role="button"
            onClick={() => {
              handleSaveDefaultTerminalSurcharge();
            }}
          >
            Save
          </span>
          <span
            class="input-group-text ml-3"
            role="button"
            onClick={() => {
              setIsDefaultSurchargeEditable(false);
                setIsOverRideVisible(false);
              setIsEditable(false);
            }}
          >
            Cancel
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Fees;
